import { render } from "./AmoCrmBlackList.vue?vue&type=template&id=2c39fd09&scoped=true&ts=true"
import script from "./AmoCrmBlackList.vue?vue&type=script&lang=ts"
export * from "./AmoCrmBlackList.vue?vue&type=script&lang=ts"

import "./AmoCrmBlackList.vue?vue&type=style&index=0&id=2c39fd09&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c39fd09"]])

export default __exports__